var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHelpCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10 2.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15M.833 10a9.167 9.167 0 1 1 18.334 0A9.167 9.167 0 0 1 .833 10m9.382-3.313a1.67 1.67 0 0 0-1.854 1.09.833.833 0 0 1-1.572-.553 3.333 3.333 0 0 1 6.478 1.11c0 1.275-.946 2.118-1.621 2.568a6.7 6.7 0 0 1-1.405.707l-.03.01-.008.003-.004.001h-.001l-.265-.79.264.79a.833.833 0 0 1-.528-1.58l.013-.005.062-.022c.056-.022.14-.055.242-.1a5 5 0 0 0 .735-.401c.575-.383.879-.79.879-1.182a1.666 1.666 0 0 0-1.385-1.646m-1.048 7.48c0-.46.373-.834.833-.834h.008a.833.833 0 0 1 0 1.667H10a.833.833 0 0 1-.833-.833",
  clipRule: "evenodd"
})));
SvgHelpCircle.displayName = "SvgHelpCircle";
export { SvgHelpCircle as ReactComponent };
export default SvgHelpCircle;